// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Dfn52","imageRight":"styles_imageRight__BU9BE","textContent":"styles_textContent__lFuJG"};